import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../Api/config';
import { FaSearch } from 'react-icons/fa';
import NotFoundPic from "../../Assets/images/tenderNotFoundImage.png"

const Sources = ({ source }) => {
  const [sources, setSources] = useState([]);
  const [filteredSources, setFilteredSources] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState('Newspaper'); // Default tab

  const navigate = useNavigate();

  const handleSourcesSelect = sourceName => {
    navigate('/limitedTenderView', { state: { sourceName } });
    window.scrollTo(0, 0);
  };

  const sectionref = useRef(null);

  // Fetch sources dynamically based on activeTab
  const fetchSources = async () => {
    setLoading(true); // Show loader while fetching data
    setError(''); // Reset error before making a new request
    try {
      const response = await axios.get(
        `${API_BASE_URL}/user/visitor/source?type=${activeTab}` // Use dynamic type
      );

      if (response.data.success) {
        const filterByStatus = response.data?.data?.filter(
          tender => tender.status === 1
        );
        const sourceData = filterByStatus || [];
        // const sourceData = response.data.data || [];
        setSources(sourceData);
        setFilteredSources(sourceData);
      } else {
        setError('Failed to fetch sources.');
      }
    } catch (err) {
      console.error(err);
      setError('An error occurred while fetching sources.');
    } finally {
      setLoading(false);
    }
  };

  // Handle search input change
  const handleSearchChange = e => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = sources.filter(source =>
      source.name.toLowerCase().includes(value)
    );
    setFilteredSources(filtered);
  };

  // Refetch sources whenever activeTab changes
  useEffect(() => {
    fetchSources();
  }, [activeTab]);

  useEffect(() => {
    sectionref.current?.scrollIntoView({ behavior: "smooth" });
  }, [activeTab]);


  return (
    <div className=" ">
      <h1 className="text-center text-xl md:text-2xl lg:text-2xl font-bold ">Tender Sources</h1>

      <div className="flex flex-col items-center md:flex-row gap-4">
        {/* Sidebar */}
        <div className="w-full md:w-1/4 bg-gray-50 rounded-md p-4 shadow border-gray-600 h-auto mb-2">
          <h2 className="text-lg font-semibold mb-4 border-b-2  border-gray-500 w-28 ">
            Sources
          </h2>
          <ul className="space-y-2 ">
            {['Newspaper', 'e-GP', 'Advertisement', 'Website', 'Manual'].map(
              tab => (
                <li key={tab}>
                  <button
                    className={`w-full text-left py-2 px-4 rounded-md transition-all duration-300 ${activeTab === tab
                      ? 'bg-blue-600 text-white shadow-md'
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                      }`}
                    onClick={() => setActiveTab(tab)}
                  >
                    {tab}
                  </button> 
                </li>
              )
            )}
          </ul>
        </div>

        {/* Content Section */}
        <div className="w-full md:w-3/4 px-1" ref={sectionref} >
          {/* Search Bar */}
          <div className="flex items-center justify-center p-4">
            <div className="relative w-full max-w-md">
              <input
                value={searchTerm}
                onChange={handleSearchChange}
                type="text"
                placeholder="Sources Name"
                className="w-full py-2 pl-4 pr-12 border border-gray-400 rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <button className="absolute inset-y-0 right-1 m-1 px-2 text-white bg-modalHeader rounded hover:bg-blue-700">
                <div className="flex gap-1 items-center text-sm md:text-base lg:text-lg">
                  <FaSearch className="w-3 h-3 md:w-4 md:h-4 lg:w-5 lg:h-5" />
                  <span className="hidden sm:inline lg:inline md:inline">
                    Search
                  </span>
                </div>
              </button>
            </div>
          </div>

          {/* Sources List */}
          <div className="   rounded-md h-96 overflow-y-auto">
            {filteredSources.length > 0 ? (
              <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {filteredSources.map((source, index) => (
                  <li
                    key={source.id}
                    className="flex items-start space-x-2 bg-gray-100 p-4 rounded-md shadow-sm first:mt-0 text-xs md:text-sm lg:text-md"
                  >
                    <span className="font-bold text-blue-600">
                      {index + 1}.
                    </span>
                    <span
                      onClick={e => {
                        e.preventDefault();
                        handleSourcesSelect(source.name);
                      }}
                      className="text-gray-700 hover:text-modalHeader cursor-pointer"
                    >
                      {source.name}
                    </span>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="flex justify-center items-center h-full">
                <img
                  className="max-w-full h-full"
                  src={NotFoundPic}
                  alt="Not Found"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sources;

